module.exports = __webpack_public_path__ + "img/polo-front.aa136df5.svg";